<template>
<broadcast-message-banner v-if="message.type.id === 'banner'"
                          :message="message"
                          :closed="closed"
                          @closed="close"
/>
<broadcast-message-modal v-else-if="message.type.id === 'modal'"
                         :closed="closed"
                         :message="message"
                         @closed="close"
/>
</template>

<script>
import { mapGetters } from 'vuex'
import storage from '@/storage'
import BroadcastMessageBanner from './broadcast-messages/BroadcastMessageBanner'
import BroadcastMessageModal from './broadcast-messages/BroadcastMessageModal'

export default {
  components: {
    BroadcastMessageBanner,
    BroadcastMessageModal,
  },

  computed: {
    ...mapGetters({
      message: 'store/broadcastMessage',
    }),

    storageKey() {
      if (!this.message) {
        return null
      }

      return `broadcastMessages.${this.message.id}.closed`
    },
  },

  methods: {
    close() {
      this.closed = true
      storage._setItem(this.storageKey, 1)
    },
  },

  watch: {
    message: {
      immediate: true,
      handler(message) {
        if (!message || !message.id) {
          return
        }

        const wasClosed = parseInt(storage._getItem(this.storageKey), 10) === 1

        if (wasClosed) {
          this.closed = wasClosed === true;

          return
        } else if (message.immediate === true) {
          this.closed = false;

          return;
        }

        setTimeout(() => this.closed = false, 2000)
      },
    },
  },

  data() {
    return {
      closed: true,
    }
  }
}
</script>
